"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _MyAccountUserInfoStyled = require("./MyAccountUserInfoStyled");
var _jsxRuntime = require("react/jsx-runtime");
const MyAccountUserInfo = () => {
  const {
    user
  } = (0, _reactRedux.useSelector)(state => state.userProfile);
  const {
    data: [plan]
  } = (0, _reactRedux.useSelector)(state => state.plan.currentPlan);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const isDataLoaded = !!user;
  const subscription = plan && t("offer-title-".concat(plan.offerId), plan.offerTitle);
  const isNameSet = (user === null || user === void 0 ? void 0 : user.firstName) || (user === null || user === void 0 ? void 0 : user.lastName);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountUserInfoStyled.WrapStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
      showChildren: isDataLoaded,
      circle: true,
      width: 80,
      height: 80,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountUserInfoStyled.PhotoStyled, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountUserInfoStyled.DetailsStyled, {
      isEmpty: !(user !== null && user !== void 0 && user.email),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: isDataLoaded,
        height: 26,
        children: isNameSet && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountUserInfoStyled.NameStyled, {
          children: "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: isDataLoaded,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountUserInfoStyled.MailStyled, {
          bigger: !isNameSet,
          children: user === null || user === void 0 ? void 0 : user.email
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: isDataLoaded,
        height: 36,
        margin: "0",
        children: subscription && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountUserInfoStyled.TextStyled, {
          children: subscription
        })
      })]
    })]
  });
};
var _default = exports.default = MyAccountUserInfo;